import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';
import _intersection from 'lodash/intersection';

export default class ApprovalAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare state: StateService;

  /**
   * User can visit visitors/approvals if they have the read permission or are blocklist contact
   */
  get canVisit(): boolean {
    const blocklistContacts = this.state.currentLocation?.blocklistContacts?.slice() ?? [];
    const isSecurityContact = !!blocklistContacts.find((contact) => contact.id === this.currentAdmin.id);

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_APPROVALS_READ) || isSecurityContact;
  }
}
